import { IdentifierType, MemberIdentifier } from '@app/core/_models/member-interface';
import storage from 'local-storage-fallback';

import { LOGIN_ID_STORAGE_ITEM_KEY } from '@app/+login/deprecated-hybrid/consts';

export function getIdentifier(value: string, type: IdentifierType): MemberIdentifier {
  return { identifier: value.trim(), identifier_type: type };
}

export const isEmail = (input: string): boolean => {
  // https://github.com/angular/angular.js/commit/f3f5cf72e
  const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return EMAIL_REGEXP.test(input);
};


export const saveIdentifierToStorage = (identifier: MemberIdentifier): void => {
  storage.setItem(LOGIN_ID_STORAGE_ITEM_KEY, JSON.stringify(identifier));
};
